<script lang="ts">
	import PolicyPage from '$lib/components/PolicyPage.svelte';
	import { m } from '$lib/paraglide/messages';
</script>

<PolicyPage title={m.refunds_title()} description="Refund and return policy for Healthy Shoes Cyprus. 14-day return window for unworn items.">
	<p>{m.refunds_intro()}</p>

	<h2>{m.refunds_right_title()}</h2>
	<p>{m.refunds_right_body()}</p>

	<h2>{m.refunds_process_title()}</h2>
	<p>{m.refunds_process_body()}</p>

	<h2>{m.refunds_cancel_title()}</h2>
	<p>{m.refunds_cancel_body()}</p>

	<h2>{m.refunds_shipping_title()}</h2>
	<p>{m.refunds_shipping_body()}</p>

	<h2>{m.refunds_exchange_title()}</h2>
	<p>{m.refunds_exchange_body()}</p>

	<h2>{m.refunds_contact_title()}</h2>
	<p>{m.refunds_contact_body()}</p>
</PolicyPage>
